module.exports = __webpack_public_path__ + "media/assets/images/icon_help-49c829ebacb697fc74e1cdaa439cfe94.png";